import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  addDataHomeDashboardDataItem: {},
  addHomeDashboardDataData: {},
  drawerOpeningStatus: {},
  HomeDashboardDataDrawerData: {},
  HomeDashboardData: [],
  allData: [],
  sorted: [],
  saleTypes: [],
  viewHomeDashboardDataStatus: false,
  viewHomeDashboardDataCloseStatus: false,
  salesMenuDashboardData: {
    summary: {},
    salesTrend: [],
    categoryPerformance: [],
    menuItems: [],
  },
  salesMenuDashboardLoading: false,
  salesMenuDashboardError: null,
};

const slice = createSlice({
  name: 'Home',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },
    updateHomeDashboardDataStatus(state, value) {
      state.viewHomeDashboardDataStatus = value.payload;
    },
    updateHomeDashboardDataCloseStatus(state, value) {
      state.viewHomeDashboardDataCloseStatus = value.payload;
    },
    getAllSaleTypesSuccess(state, action) {
      state.saleTypes = action.payload.data;
    },
    getDrawerOpeningStatus(state, action) {
      state.drawerOpeningStatus = action.payload.data;
    },
    getHomeDashboardDataDrawerData(state, action) {
      state.HomeDashboardDataDrawerData = action.payload.data;
    },
    getHomeDashboardDataSuccess(state, action) {
      state.data = action.payload.data;
    },
    getSalesMenuDashboardStart: (state) => {
      state.salesMenuDashboardLoading = true;
      state.salesMenuDashboardError = null;
    },
    getSalesMenuDashboardSuccess: (state, action) => {
      state.salesMenuDashboardData = action.payload.data;
      state.salesMenuDashboardLoading = false;
    },
    getSalesMenuDashboardError: (state, action) => {
      state.salesMenuDashboardError = action.payload;
      state.salesMenuDashboardLoading = false;
    },
    getAllHomeDashboardDataData(state, action) {
      state.allData = action.payload.data;
    },
    addOrUpdateHomeDashboardData(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },
    addOrUpdateHomeDashboardDataItemStatus(state, action) {
      state.addDataHomeDashboardDataItem = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },
    clearAddOrUpdateHomeDashboardData(state) {
      state.addData = { data: null, time: moment.now().toString() };
    },
    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },
    onNextStep(state) {
      state.checkout.activeStep += 1;
    },
    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

export default slice.reducer;

export function getHomeDashboardData(data) {
  return async () => {
    try {
      const response = await get(`getHomeDashboardData`, data);
      if (response.status) {
        dispatch(slice.actions.getHomeDashboardDataSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getGuestDataForDateRange(data) {
  return async () => {
    try {
      const response = await get(`getGuestDataForDateRange`, data);
      if (response.status) {
        dispatch(slice.actions.getHomeDashboardDataSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export const getSalesMenuDashboard = (data) => async () => {
  dispatch(slice.actions.getSalesMenuDashboardStart());
  try {
    const response = await get('getSalesMenuDashboardData', data);
    if (response.status) {
      dispatch(slice.actions.getSalesMenuDashboardSuccess(response));
    } else {
      dispatch(slice.actions.getSalesMenuDashboardError(response.message));
    }
  } catch (error) {
    dispatch(slice.actions.getSalesMenuDashboardError(error.message));
  }
};
